<div
  class="container p-4 mx-auto bg-white rounded-lg shadow-lg sm:p-6 lg:p-8"
  *ngIf="object">
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">
            Invoices
          </h1>
          <p class="text-sm text-primary-500">View all of Your Invoices</p>
        </div>
      </div>
      <div class="flex items-center justify-between">
        <p-breadcrumb class="max-w-full" [model]="breadCrumbItems" [home]="home" />
      </div>
    </div>

    <div class="px-2 mb-8">
    <div
      class="flex flex-col items-start justify-between mb-4 sm:flex-row sm:items-center">
      <div>
        <h1 class="text-3xl font-bold text-gray-800">INVOICE</h1>
        <p class="text-gray-600"># {{ object.invoice_number }}</p>
        <p class="text-gray-600">
          {{ object.createdAt | date : "mediumDate" }}
        </p>
      </div>
      <div class="mt-2 text-sm text-gray-600 sm:mt-0 sm:text-right">
        <p>
          <span class="font-semibold">Status:</span>
          <span
            [ngClass]="{
              'text-green-600': object.status === 'PAID',
              'text-yellow-600':
                object.status === 'pending' || object.status === 'sent',
              'text-red-600':
                object.status === 'overdue' || object.status === 'draft',
              'text-gray-500':
                object.status === 'cancelled' || object.is_deleted
            }"
            class="p-1 font-medium rounded">
            {{ object.is_deleted ? "DELETED" : (object.status | uppercase) }}
          </span>
        </p>
        <p *ngIf="object.sent">
          <span class="font-semibold">Sent:</span>
          Yes
        </p>
      </div>
    </div>

    <div
      class="grid grid-cols-1 gap-4 mb-6 text-sm sm:grid-cols-2 md:grid-cols-3">
      <div>
        <h2 class="mb-1 font-semibold text-gray-700">Customer:</h2>
        <a
          *ngIf="object.customer?.id"
          [routerLink]="['/admin/customers/view', object.customer?.id]"
          class="text-blue-600 hover:underline">
          {{ object.customer?.name }}
        </a>

        <span *ngIf="!object.customer?.id" class="text-gray-600">N/A</span>
        <p class="text-xs text-gray-500">
          ID: {{ object.customer?.id || "N/A" }}
        </p>
      </div>
      <div>
        <h2 class="mb-1 font-semibold text-gray-700">Due Date:</h2>
        <p class="text-gray-600">{{ object.due_date | date : "medium" }}</p>
      </div>
      <div *ngIf="object.document_url">
        <h2 class="mb-1 font-semibold text-gray-700">Document:</h2>
        <a
          [href]="object.document_url"
          target="_blank"
          class="text-indigo-600 hover:text-indigo-800 hover:underline">
          View Document
        </a>
        <br/>
        <a
          (click)="sendDocument()"
          target="_blank"
          class="text-indigo-600 cursor-pointer hover:text-indigo-800 hover:underline">
          Send Document
        </a>
      </div>
    </div>
    <div
      *ngIf="object.reference_keys && object.reference_keys.length > 0"
      class="mb-4 text-sm">
      <h3 class="mb-1 font-semibold text-gray-700">References:</h3>
      <ul class="ml-4 list-disc list-inside">
        <li
          *ngFor="let ref of object.reference_keys.data"
          class="text-gray-600">
          {{ ref.referenceType }}: {{ ref.name }}
        </li>
      </ul>
    </div>
  </div>

  <div class="mb-8 overflow-x-auto">
    <table class="min-w-full bg-white border border-gray-200">
      <thead class="text-gray-700 bg-gray-100">
        <tr>
          <th
            class="px-4 py-3 text-xs font-semibold text-left uppercase sm:text-sm">
            Line Type
          </th>
          <th
            class="px-4 py-3 text-xs font-semibold text-left uppercase sm:text-sm">
            Description
          </th>
          <th
            class="px-4 py-3 text-xs font-semibold text-right uppercase sm:text-sm">
            Period Start
          </th>
          <th
            class="px-4 py-3 text-xs font-semibold text-right uppercase sm:text-sm">
            Period End
          </th>
          <th
            class="w-20 px-4 py-3 text-xs font-semibold text-right uppercase sm:text-sm sm:w-24">
            Qty
          </th>
          <th
            class="px-4 py-3 text-xs font-semibold text-right uppercase sm:text-sm w-28 sm:w-32">
            Unit Price
          </th>
          <th
            *ngIf="showDiscountColumn"
            class="w-24 px-4 py-3 text-xs font-semibold text-right uppercase sm:text-sm sm:w-28">
            Discount
          </th>
          <th
            class="px-4 py-3 text-xs font-semibold text-right uppercase sm:text-sm w-28 sm:w-32">
            Line Total
          </th>
        </tr>
      </thead>
      <tbody class="text-gray-700">
        <tr
          *ngFor="let line of object.lines.data; let i = index"
          [ngClass]="{ 'bg-gray-50': i % 2 !== 0 }"
          class="transition-colors duration-150 border-b border-gray-200 hover:bg-gray-100">
          <td class="px-4 py-3 text-sm">
            {{ line.line_type }}
          </td>
          <td class="px-4 py-3 text-sm">
            <a
            *ngIf="line.subscription"
            [routerLink]="['/admin/subscriptions/view', line.subscription!.id]"
            class="text-blue-600 hover:underline">
            {{ line.subscription.name }}
          </a>
  
          <span *ngIf="!line.description" class="text-gray-600">{{line.description}} </span>
          </td>
          <td class="px-4 py-3 text-sm text-right">
            {{ line.period_start | date : "shortDate" }}
          </td>
          <td class="px-4 py-3 text-sm text-right">
            {{ line.period_end | date : "shortDate" }}
          </td>
          <td class="px-4 py-3 text-sm text-right">{{ line.quantity }}</td>
          <td class="px-4 py-3 text-sm text-right">
            {{ line.unit_price | currency : "USD" }}
          </td>
          <td
            *ngIf="showDiscountColumn"
            class="px-4 py-3 text-sm text-right text-red-500">
            {{ line.discount_total ? line.discount_total : "-" }}
          </td>
          <td class="px-4 py-3 text-sm font-medium text-right">
            {{ line.line_total | currency : "USD" }}
          </td>
        </tr>
        <tr *ngIf="!object.lines || object.lines.length === 0">
          <td
            [attr.colspan]="showDiscountColumn ? 5 : 4"
            class="px-4 py-4 text-center text-gray-500">
            No line items.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex flex-col items-start justify-between px-2 sm:flex-row">
    <div class="w-full mb-6 text-sm sm:w-1/2 sm:mb-0">
      <h3 class="mb-1 font-semibold text-gray-700">Comments:</h3>
      <div
        *ngIf="object.comments && object.comments.length > 0"
        class="space-y-1">
        <p
          *ngFor="let comment of object.comments.data"
          class="p-2 text-gray-600 border border-gray-200 rounded bg-gray-50">
          {{ comment.name }}
          <span class="block text-xs text-gray-400">
            - {{ comment.createdAt | date : "medium" }}
          </span>
        </p>
      </div>
      <p
        *ngIf="!object.comments || object.comments.length === 0"
        class="italic text-gray-500">
        No comments.
      </p>
    </div>

    <div class="w-full space-y-1 text-sm text-gray-700 sm:w-auto sm:text-base">
      <div class="flex justify-between py-1">
        <span class="font-medium">Subtotal (Excl. Tax):</span>
        <span>{{ formatCurrency(object.excluding_tax) }}</span>
      </div>
      <div
        class="flex justify-between py-1 text-red-600"
        *ngIf="object.discount_value > 0">
        <span class="font-medium">Invoice Discount:</span>
        <span>- {{ formatCurrency(object.discount_value) }}</span>
      </div>
      <hr class="my-1 border-gray-300" />
      <div class="flex justify-between py-1">
        <span class="font-medium">Amount Before Tax:</span>
        <span>
          {{ formatCurrency(object.excluding_tax - object.discount_value) }}
        </span>
      </div>
      <div class="flex justify-between py-1">
        <span class="font-medium">Tax:</span>
        <span>{{ formatCurrency(object.tax) }}</span>
      </div>
      <hr class="my-1 border-gray-300" />
      <div class="flex justify-between py-1 text-lg font-bold">
        <span>Grand Total (Incl. Tax):</span>
        <span>{{ formatCurrency(object.including_tax) }}</span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!object" class="p-8 text-center">
  <p class="text-gray-500">Loading invoice data...</p>
</div>
